var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_3_105)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.65 10C11.825 7.67 9.61 6 7 6C3.685 6 1 8.685 1 12C1 15.315 3.685 18 7 18C9.61 18 11.825 16.33 12.65 14H17V18H21V14H23V10H12.65ZM7 14C5.895 14 5 13.105 5 12C5 10.895 5.895 10 7 10C8.105 10 9 10.895 9 12C9 13.105 8.105 14 7 14Z"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_3_105"
    }
  }, [_c('rect', {
    attrs: {
      "width": "24",
      "height": "24"
    }
  })])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }